module.exports = __webpack_public_path__ + "img/63.3.TP.33c90524.png";